// Hours rounding shared by exports, the team report table and the client (architecture sprint-05
// §3.5). Dependency-free (shared-purity.test.ts). Rule everywhere: sum seconds, then round once.

/** Seconds per hundredth of an hour: round(s / 36) / 100 gives hours to 2 dp. */
const SECONDS_PER_CENTIHOUR = 36;
const CENTI = 100;
const HOURS_DECIMALS = 2;

/** Hours to 2 dp, rounded once from seconds: 5400 → 1.5, 59 → 0.02, 1 → 0, 86400 → 24. */
export function hoursFromSeconds(seconds: number): number {
  return Math.round(seconds / SECONDS_PER_CENTIHOUR) / CENTI;
}

/** hoursFromSeconds(s).toFixed(2): 5400 → '1.50', 0 → '0.00'. */
export function formatHours2(seconds: number): string {
  return hoursFromSeconds(seconds).toFixed(HOURS_DECIMALS);
}
